export enum ProjectListOrderDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}
